import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/es-mx';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es-mx');

const TZ = 'America/Mexico_City';

export function formatDateMx(iso: string): string {
    return dayjs(iso).tz(TZ).format('DD/MM/YYYY');
}

export function formatDateTimeMx(iso: string): string {
    return dayjs(iso).tz(TZ).format('DD/MM/YYYY HH:mm');
}

export function formatRelativeMx(iso: string): string {
    return new Intl.RelativeTimeFormat('es-MX', { numeric: 'auto' }).format(
        Math.round((dayjs(iso).valueOf() - Date.now()) / 1000 / 60),
        'minute',
    );
}
